export default __webpack_public_path__ + "static/media/trylleby-property-25.7d213a8f.jpg";